import { render, staticRenderFns } from "./InventoryListGroup.vue?vue&type=template&id=588ca9a8&"
import script from "./InventoryListGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports